import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I Don't Know",
  "description": "",
  "published": "2012-01-24T00:00:00.000Z",
  "redirect_from": ["/blog/i-dont-know/swizec/3517"],
  "categories": "Albert Einstein, BBC, Feynman, Knowledge, Richard Feynman, Uncategorized, YouTube",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "Na-KzVwu6es",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`I. Don't. Know.`}</p>
    <p>{`Three simple words. Almost impossible to say. As developers, as entrepreneurs, as `}<em parentName="p">{`men`}</em>{` we never want to admit we don't know. If you don't know, you are weak and an army of angry huns will come to steal your women, your business and your honor.`}</p>
    <p>{`When founders don't know what the hell they're doing, people leave, investors say "maybe" and users aren't showing up. `}<em parentName="p">{`Especially`}</em>{` if they openly admit they don't know.But just as some consider not knowing a sign of weakness, `}<em parentName="p">{`always`}</em>{` knowing is definitely a sign of weakness. Selling your best guess as absolute fact works very well in the short term, in fact it works spectacularly well - there's a reason there are whole books devoted to the practice of eliminating excuses from your speech. Phrases like `}<em parentName="p">{`I think,`}</em>{` `}<em parentName="p">{`in my opinion`}</em>{` et cetera.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/Maldives-Island_1111082i1.jpg",
        "alt": "Island of knowledge",
        "title": "Island of knowledge"
      }}></img></p>
    <p>{`While it's important to commit to what you say without hedging and ways to weasel out when you're proven wrong. It's even more important to admit when you don't know. In fact all that hedging just defends you from admitting you are wrong and `}<em parentName="p">{`don't know.`}{`_`}{`The best thinkers of our species, like `}<a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Richard_Feynman",
          "title": "Richard Feynman"
        }}>{`Feynman`}</a>{`, `}<a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Albert_Einstein",
          "title": "Albert Einstein"
        }}>{`Einstein`}</a>{` and others, are `}{`_`}{`glorified`}</em>{` for their ability to embrace what they don't know. To look `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Ignorance",
        "title": "Ignorance"
      }}>{`ignorance`}</a>{` straight in the face and spit in its eye. Most of us cower from such an opportunity, we like nothing more than to stand firmly in the middle of what we know and never looking beyond the horizon lest there be monsters.Someone once said `}<em parentName="p">{`Every man lives on an island of knowledge in a sea of ignorance. The bigger your island, the longer the shore of ignorance`}</em>{`.`}</p>
    <p>{`Most people can't even comprehend how much they don't know about a subject, because the more you know about something, the more you understand the intricacies involved. A common saying amongst developers is `}<em parentName="p">{`What the fuck man!? How can That Startup spend so much money on that simple problem, it's just `}{`<`}{`x>, `}{`<`}{`y>, `}{`<`}{`z> and you're done. I could do it in a week!`}</em></p>
    <p>{`Chances are, you don't know what the hell you are talking about. The hardest problems seem the simplest when given only a cursory glance. So put down the ego for a moment and `}<em parentName="p">{`prove it.`}</em>{` Prove that the problem is simple.`}</p>
    <p>{`You can't learn what you already know. ;)`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.brainpickings.org/index.php/2011/10/07/richard-feynman-on-beauty-honors-and-curiosity/"
        }}>{`Richard Feynman on Beauty, Honors, and Curiosity`}</a>{` (brainpickings.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://crcpastorchad.wordpress.com/2011/10/04/beauty-and-doubt/"
        }}>{`Beauty and doubt`}</a>{` (crcpastorchad.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://callumjameshackett.wordpress.com/2011/12/27/physicists-and-artists/"
        }}>{`Physicists and Artists`}</a>{` (callumjameshackett.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.brainpickings.org/index.php/2011/12/14/bbcs-richard-feynman-no-ordinary-genius/"
        }}>{`No Ordinary Genius: BBC Captures Richard Feynman's Legacy`}</a>{` (brainpickings.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://iantimberlake.wordpress.com/2011/12/29/inspiring-and-powerful-science-quotes/"
        }}>{`Inspiring and Powerful Science Quotes`}</a>{` (iantimberlake.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.quantumdiaries.org/2011/10/10/quantum-man-richard-feynmans-life-in-science/"
        }}>{`Quantum Man: Richard Feynman's Life in Science`}</a>{` (quantumdiaries.org)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=7a25ffe7-e8f9-437e-bb23-543e63b1c4e9",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      